import{app} from "../firebase/data"
import { getStorage,ref,uploadBytes,getDownloadURL } from "firebase/storage";
import { getFirestore, collection, 
    doc, setDoc,
    query, where,getDocs
  } from "firebase/firestore";


// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const storage = getStorage(app);
const notesRef = collection(db, "notes");
import {toast} from "react-hot-toast";


//!UPLOAD NOTE
export async function uploadArchive(file,path){
    let storageRef = ref(storage, path);

    return uploadBytes(storageRef, file).then((snapshot) => {
        toast.success("Archivo cargado!")
        //console.log('Uploaded a blob or file! ' + path);
        return path;
    })
}

export async function uploadNote (user, archiveName, archiveURL, year) {

    try {
        const docRef = await setDoc(doc(notesRef, archiveURL), {
            user,
            archiveName,
            archiveURL,
            year
        })
        toast.success("Apunte subido!")
        //console.log("Document written: "+archiveURL)
    
      } catch (error) {
        toast.error("Ocurrió un error")
        //console.error("Error adding document: ", error);
      }
}



//!DOWNLOAD NOTE
export async function downloadNotes (path) {
    const storageRef = ref(storage, path);

    return getDownloadURL(storageRef)
    .then((url) => {
      //console.log("url obtenido")
      //console.log(url)
      toast.success("Link obtenido")
      return url;

    })
    .catch((error) => {

      switch (error.code) {
      case 'storage/object-not-found':
          toast.error('Storage error: objeto no encontrado')
          break;
      case 'storage/unauthorized':
          toast.error('Storage error: No autorizado')
          break;
      case 'storage/canceled':
          toast.error('Storage error: Subida cancelada')
          break;
      case 'storage/unknown':
          toast.error("Error desconocido")
          break;
        }
    })
}


//!DELETE NOTE
  export async function deleteNote (params) {
    
}

//!READ NOTE
export async function readNotes () {
    const  querySnapshot = await getDocs(notesRef);
    //console.log("It´s QuerySnapShot: "+querySnapshot);
    //console.log("It´s QuerySnapShot.docs: "+querySnapshot.docs);

  const notesList=querySnapshot.docs.map(doc => {
    return {...doc.data(),id:doc.id}

    })
    return notesList;
}